import {
  Badge,
  Box,
  Button,
  Center,
  Group,
  List,
  Paper,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import { IconCheck, IconLogin } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/auth/AuthProvider';
import { appConfig } from '@/auth/authConfig';

export function LoginPage() {
  const { t } = useTranslation('common');
  const { login, isAuthenticated } = useAuth();
  return (
    <Box
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        className="lft-landing-grid"
        style={{
          flex: 1,
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
        }}
      >
        {/* Linke Spalte — Hero */}
        <Box
          px={48}
          py={48}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Stack gap="lg" maw={520}>
            <Group justify="space-between" align="flex-start">
              <img
                src="/brand/lag-logo.jpg"
                alt="LAG Hessen — Freie Kitaträger"
                style={{ height: 120, width: 'auto' }}
              />
              <Badge
                color={appConfig.appEnv === 'prod' ? 'red' : 'orange'}
                variant="light"
                size="lg"
              >
                {appConfig.appEnv === 'prod'
                  ? t('app.envBadge.prod')
                  : t('app.envBadge.dev')}
              </Badge>
            </Group>

            <Stack gap={2}>
              <Title order={1} c="#072c5e">
                {t('landing.title')}
              </Title>
              <Text size="lg" c="dimmed">
                {t('landing.subtitle')}
              </Text>
            </Stack>

            <Text c="#333">{t('landing.lead')}</Text>

            <List
              spacing="xs"
              icon={
                <Box
                  style={{
                    width: 20,
                    height: 20,
                    borderRadius: '50%',
                    background: '#37B6BD',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <IconCheck size={14} />
                </Box>
              }
            >
              <List.Item>{t('landing.feature1')}</List.Item>
              <List.Item>{t('landing.feature2')}</List.Item>
              <List.Item>{t('landing.feature3')}</List.Item>
              <List.Item>{t('landing.feature4')}</List.Item>
            </List>
          </Stack>
        </Box>

        {/* Rechte Spalte — Login-Karte */}
        <Box
          px="md"
          py={48}
          style={{
            background: 'rgba(55, 182, 189, 0.08)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Center>
            <Paper p="xl" withBorder shadow="md" w={400} radius="sm">
              <Stack>
                <Title order={3} c="#072c5e">
                  {t('landing.loginTitle')}
                </Title>
                <Text size="sm" c="dimmed">
                  {t('landing.loginSubtitle', {
                    realm: appConfig.appEnv === 'prod' ? 'lft' : 'lft-dev',
                  })}
                </Text>
                <Button
                  size="md"
                  color="lag"
                  leftSection={<IconLogin size={18} />}
                  onClick={() => void login()}
                  disabled={isAuthenticated}
                  fullWidth
                >
                  {t('nav.login')}
                </Button>
                <Text size="xs" c="dimmed" ta="center">
                  {t('landing.loginHint')}
                </Text>
              </Stack>
            </Paper>
          </Center>
        </Box>
      </Box>

      <style>{`
        @media (max-width: 768px) {
          .lft-landing-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </Box>
  );
}
